import React from 'react';
import './TopBar.css';

interface TopBarProps {
  title: string;
  onBack?: () => void;
  onMore?: () => void;
  showBack?: boolean;
  showMore?: boolean;
  /** 左侧为返回箭头或关闭（×），仅在 showBack 为 true 时生效 */
  leftIcon?: 'back' | 'close';
  /** 顶栏背景：default 为灰底，white 为白底（与设计稿一致） */
  tone?: 'default' | 'white';
}

export const TopBar: React.FC<TopBarProps> = ({
  title,
  onBack,
  onMore,
  showBack = true,
  showMore = false,
  leftIcon = 'back',
  tone = 'default',
}) => {
  return (
    <div className={`topbar ${tone === 'white' ? 'topbar--white' : ''}`}>
      <div className="topbar-safe" />
      <div className="topbar-main">
        <button
          className="topbar-btn"
          aria-label={leftIcon === 'close' ? 'close' : 'back'}
          style={{ visibility: showBack ? 'visible' : 'hidden' }}
          onClick={() => onBack?.()}
        >
          {leftIcon === 'close' ? (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 5L15 15M15 5L5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </button>
        <div className="topbar-title">{title}</div>
        <button
          className="topbar-btn topbar-btn-more"
          aria-label="more"
          style={{ visibility: showMore ? 'visible' : 'hidden' }}
          onClick={() => onMore?.()}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="10" r="1.5" fill="currentColor" />
            <circle cx="10" cy="10" r="1.5" fill="currentColor" />
            <circle cx="16" cy="10" r="1.5" fill="currentColor" />
          </svg>
        </button>
      </div>
    </div>
  );
};


